<template>
  <router-link :to="route">
    <fa-layers class="fa-2x">
      <fa :icon="['far','comment']" />
      <fa-layers-text class="gray8" transform="up-1 shrink-10" :value="notificationsCount" />
    </fa-layers>
  </router-link>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'notifications-icon',
  props: {
    count: {
      type: Number,
      default: -1
    },
    userId: {
      type: Number,
    },
    authUser: Boolean,
    route: {
      type: Object,
      default: () => ({ name: 'messages' })
    },
  },
  computed: {
    ...mapGetters('auth', ['roles', 'user', 'isAdmin', 'isSiteTeam', 'isParticipant']),
    ...mapGetters('messages', ['message_notifications','recipient']),
    notificationsCount() {
      if (this.count>-1) return this.count
      return this.message_notifications.length
    }
  },
  mounted() {
    if (this.authUser) {
      this.getMessageNotifications()
      this.listenForWebsocketNotifications()
    }
  },
  watch:{
    user () {
      if (this.authUser) {
        this.getMessageNotifications()
        this.listenForWebsocketNotifications()
      }
    }
  },
  methods: {
    ...mapActions('messages', ['getMessageNotifications', 'insertMessage', 'insertNotification']),
    listenForWebsocketNotifications() {
      if(config.broadcast_driver=='pusher'){
        if (this.isAdmin) {
          Echo.private('App.CentralAdmin.1')
            .notification((notification) => {
              if (notification.type == "App\\Notifications\\Message") {
                var m = notification.data
                this.insertNotification(notification)
                if(m.sender_type == "App\\User" && this.recipient && m.sender_id == this.recipient.id) this.insertMessage(notification.data)
              }
            });
        } else {
          Echo.private('App.User.' + this.user.id)
            .notification((notification) => {
              if (notification.type == "App\\Notifications\\Message") {
                this.insertNotification(notification)
                this.insertMessage(notification.data)
              }
            });
        }
      }
    }
  }
}

</script>
